export class RedefinirSenhaModel{
    public HashRecuperacao: string;
    public NovaSenha: string;

    constructor(hashRecuperacao: string, novaSenha: string){
        this.HashRecuperacao =  hashRecuperacao;
        this.NovaSenha = novaSenha
    }
}